
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";

export const uploadGameCover = async (gameId: string, coverFile: File | null, existingUrl: string): Promise<string | null> => {
  if (!coverFile) {
    console.log(`No cover file provided for game ${gameId}, keeping existing URL: ${existingUrl}`);
    return existingUrl; // Return existing URL if no new file
  }

  try {
    const fileExt = coverFile.name.split(".").pop();
    const timestamp = Date.now();
    const fileName = `game-${gameId}-${timestamp}.${fileExt}`;
    const filePath = fileName;

    console.log(`Uploading file for game ${gameId}:`, filePath);
    console.log(`File type: ${coverFile.type}, size: ${coverFile.size} bytes`);

    // Check if the games bucket exists, create if not (this addresses potential issues)
    const { data: buckets } = await supabase.storage.listBuckets();
    if (!buckets?.some(bucket => bucket.name === 'games')) {
      console.log('Games bucket not found, creating...');
      await supabase.storage.createBucket('games', { public: true });
    }

    // Remover arquivo antigo se existir (evitar acúmulo de arquivos)
    if (existingUrl) {
      try {
        const oldFileName = existingUrl.split('/').pop();
        if (oldFileName && oldFileName.startsWith(`game-${gameId}`)) {
          console.log(`Removing old file: ${oldFileName}`);
          await supabase.storage.from("games").remove([oldFileName]);
        }
      } catch (removeError) {
        console.log('Could not remove old file (this is not critical):', removeError);
      }
    }

    // Upload to the games bucket
    const { error: uploadError, data: uploadData } = await supabase.storage
      .from("games")
      .upload(filePath, coverFile, { upsert: false });

    if (uploadError) {
      console.error("Upload error:", uploadError);
      toast({
        title: "Erro",
        description: "Falha ao fazer upload da imagem: " + uploadError.message,
        variant: "destructive",
      });
      return null;
    }

    console.log('Upload successful:', uploadData);

    // Get the public URL with cache-busting parameter
    const { data: urlData } = supabase.storage.from("games").getPublicUrl(filePath);
    const finalUrl = `${urlData.publicUrl}?t=${timestamp}`;
    
    console.log('Image uploaded successfully, public URL:', finalUrl);
    return finalUrl;
  } catch (error) {
    console.error("Upload error:", error);
    toast({
      title: "Erro",
      description: "Ocorreu um erro inesperado durante o upload.",
      variant: "destructive",
    });
    return null;
  }
};
